import React from 'react'

class InstrumentSetDuty extends React.Component {
    state = {
        ids: this.props.ids || [],
    }

    componentDidMount = () => {
		const { ids } = this.state
        Tyan.doPostEvent('GetInstrumentDuty', {
            data: { ids: ids || 0,  },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
		const { ids, changedValues基本信息 } = this.state
        console.log('ids',ids)
        Tyan.doPostEvent('SaveInstrumentDuty', {
            data: { ids, changedValues基本信息:changedValues基本信息 },
            onEnd: ({ errorMessage, FID }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
					Ext.toast('设置成功')
                    onClose && onClose()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }


    canSave = () => {
        return this.bChanged() && !Tyan.checkForm.checkLimited(this)
    }

    bChanged = () => {
        return Tyan.utility.hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        return [
            { _select: '设备责任人', required: true, editable: true, forceSelection: true, },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={600}
            controls={
                [
                    { _button: '保存', handler: this.handlerSave, disabled: !this.canSave() },
                    { _button: this.bChanged() && '取消' || '关闭', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default InstrumentSetDuty